import React, { Component } from 'react';
import CommentsList from './CommentsList';
import { connect } from 'react-redux';
import _ from 'lodash';
import {emptyComments} from '../../actions/index'

import CommentForm from './CommentForm';

class CommentContainer extends Component{
    onClick() {
        this.setState({ showComments: !this.state.showComments });
    }
    renderTitle(){
        if(!_.isEmpty(this.props.comments)){
            return(<span>Comment {this.props.comments.length}</span>)
        }else{
            return(<span>Comment</span>)
        }
    }

    render(){
        return(
            <div className="comment-container">
                <CommentsList comments={this.props.comments} user_id={this.props.user_id} />
                <CommentForm caso_id={this.props.caso_id} />
            </div>
            )
    }
}
function mapStateToProps(state) {
    return {
        comments: state.comments,
        caso: state.caso,
        caso_id: state.caso.id,
        user_id: state.user.id
    };
}

export default connect(mapStateToProps, {emptyComments})(CommentContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/comments/CommentContainer.jsx